import React, { useContext } from 'react';
import styles from './ProfileLink.module.scss';
import { SettingsContext } from '../../contexts/settings-provider';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ProfileLink = ({ className }) => {
  const [settings] = useContext(SettingsContext);

  return (
    <Link to={'/profile'} className={classNames(styles.link, className)}>
      <span className={styles.text}>Profile</span>
      <div className={styles.icon}>{settings.user.email[0]}</div>
    </Link>
  );
};

ProfileLink.propTypes = {
  className: PropTypes.string,
};

ProfileLink.defaultProps = {
  className: null,
};

export default ProfileLink;
